import { useLocation } from 'react-router';
import { useMemo } from 'react';

export const useQueryString = () => {
  // TODO: Replace all the use of `getQuerystring` function with this hook
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};